import { SegmentDataStructureType } from "@redotech/redo-customer-segments-common/marketing/segments/segment-data-structures";
import { ListCompareOperators } from "@redotech/redo-customer-segments-common/segments/segment-where-condition";
import { ListCompare } from "@redotech/redo-customer-segments-common/segments/segment-where-condition-zod-schema";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";
import { MultipleTokenOptionSelect } from "./token-filter";

const listCompareOperatorToFriendly: Record<ListCompareOperators, string> = {
  [ListCompareOperators.ANY]: "include any of",
  [ListCompareOperators.NONE]: "include none of",
  [ListCompareOperators.ALL]: "have all of",
};

const listCompareOptions: RedoListItem<ListCompareOperators>[] = Object.values(
  ListCompareOperators,
).map((value) => ({
  id: value,
  text: listCompareOperatorToFriendly[value],
  value,
  type: "text",
}));

import { CustomerDataSource } from "@redotech/redo-customer-segments-common/marketing/segments/segment-types";

export const TokenListFilter = memo(function TokenListFilter({
  comparison,
  setComparison,
  dimension,
  fieldSource,
  dataStructure,
}: {
  comparison: ListCompare;
  setComparison: (condition: ListCompare) => void;
  dimension: string;
  fieldSource?: CustomerDataSource;
  dataStructure: SegmentDataStructureType;
}) {
  return (
    <>
      <RedoSingleSelectDropdownInput<ListCompareOperators>
        fitToAnchor={false}
        flexGrow={false}
        options={listCompareOptions}
        optionSelected={({ item }) => {
          setComparison({ ...comparison, operator: item.value });
        }}
        selectedItem={listCompareOptions.find(
          (item) => item.id === comparison.operator,
        )}
        size="xs"
      />
      <MultipleTokenOptionSelect
        dataStructure={dataStructure}
        dimension={dimension}
        fieldSource={fieldSource}
        key={dimension}
        selectedValues={comparison.values}
        setSelectedValues={(values) => {
          setComparison({ ...comparison, values });
        }}
      />
    </>
  );
});
